export default {
	loading: false,
	references: [],
	errors: {
		id: '',
		name: false,
		description: false
	},
};